import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class AdminProvider {

  constructor(public http: HttpClient) { }

  deleteAccount(token: string, uuid: string): Observable<object> {
    const url: string = "https://us-central1-gepp-bdcd3.cloudfunctions.net/user-delete";
    const body = {
      "token": token,
      "uuid": uuid
    }
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.http.post(url, body, httpOptions);
  }

  createAccount(token: string, password: string, userData: any): Observable<object> {
    const url: string = "https://us-central1-gepp-bdcd3.cloudfunctions.net/user-create";
    const body = {
      "token": token,
      "user": {
        "password": password,
        "userData": userData
      }
    }
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.http.post(url, body, httpOptions);
  }

  createUsers(token: string, downloadUrl: string): Observable<object> {
    const url: string = "https://us-central1-gepp-bdcd3.cloudfunctions.net/users-create";
    const body = {
      "token": token,
      "downloadUrl": downloadUrl
    }
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.http.post(url, body, httpOptions);
  }

  deleteUsers(token: string, downloadUrl: string): Observable<object> {
    const url: string = "https://us-central1-gepp-bdcd3.cloudfunctions.net/users-delete";
    const body = {
      "token": token,
      "downloadUrl": downloadUrl
    }
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.http.post(url, body, httpOptions);
  }

  updateUsers(token: string, downloadUrl: string): Observable<object> {
    const url: string = "https://us-central1-gepp-bdcd3.cloudfunctions.net/users-update";
    const body = {
      "token": token,
      "downloadUrl": downloadUrl
    }
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.http.post(url, body, httpOptions);
  }

}



// WEBPACK FOOTER //
// ./src/providers/admin/admin.ts